<template>
  <GModal v-if="isDesktop" id="modal--change-number" class="custom-modal modal-mask new-form">
    <template slot="header">
      <p class="head">CHANGE PHONE NUMBER</p>
      <span class="close modal-heading--close" @click.prevent="closeModal">
        <img src="/assets/img/icons/close-modal.svg" />
      </span>
    </template>
    <div slot="body" style="height: 100%; position: relative">
      <div class="change-number-wrap active">
        <form
          id="form-change-number"
          method="post"
          name="form-change-number"
          data-vv-scope="form-change-number"
          @submit.prevent="$emit('submitted', phone_no)"
        >
          <div class="field" :class="{ 'has-error': errors.has('form-change-number.hp') }">
            <div class="hp-label-wrapper">
              <label class="text-label" for="hp">Mobile Phone number <span class="required">*</span></label>
              <label class="text-label" for="hp">Contoh: <strong>85612345678</strong></label>
            </div>
            <div class="fieldarea fieldarea--addon fieldarea--input-with-text">
              <div>
                <span class="fieldarea__addon" @click.prevent="showOverseas()">
                  <template v-if="userCountry && !Object.keys(userCountry).length">
                    <span class=""
                      ><img src="/assets/img/indonesia-flag.svg" class="field__icon-flag" />+62<img
                        src="/assets/img/triangle-down.svg"
                        class="field__icon-triangle"
                    /></span>
                  </template>
                  <template v-else>
                    <span class=""
                      ><img :src="userCountry.flag" class="field__icon-flag" />{{ `${userCountry.phone_code}`
                      }}<img src="/assets/img/triangle-down.svg" class="field__icon-triangle"
                    /></span>
                  </template>
                </span>
                <overseas-phone v-if="isShowModalOverseas" />
              </div>
              <input
                id="minhp"
                v-model="phone_no"
                v-validate="'required|numeric|min:4|max:14'"
                type="text"
                class="text addon"
                name="minhp"
                autocomplete="off"
              />
            </div>
            <p v-show="errors.has('form-change-number.minhp')" class="alert">
              {{ errors.first('form-change-number.minhp') }}
            </p>
          </div>
          <div class="change-number-action">
            <template v-if="!showLoader">
              <button v-show="isDesktop" class="button button-dismiss" @click.prevent="closeModal">CANCEL</button>
              <button
                type="submit"
                class="button button-danger"
                :disabled="errors.has('form-change-number.minhp') || !phone_no"
              >
                CHANGE AND SEND OTP
              </button>
            </template>
            <loaderspin v-else />
          </div>
        </form>
      </div>
    </div>
  </GModal>
  <div v-else>
    <GModal id="pills-dropdown-mobile" class="pills-dropdown-mobile">
      <template slot="header">
        <div class="rectangle-top"></div>
        <div class="modal-heading">
          <h4 class="modal-heading--title">CHANGE PHONE NUMBER</h4>
          <a
            href=""
            type="button"
            class="close modal-heading--close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="closeModal"
          >
            <img src="/assets/img/icons/close-modal.svg" height="14" width="14" />
          </a>
        </div>
      </template>
      <template slot="body">
        <div class="content-modal">
          <div class="change-number-wrap active">
            <form
              id="form-change-number"
              method="post"
              name="form-change-number"
              data-vv-scope="form-change-number"
              @submit.prevent="$emit('submitted', phone_no)"
            >
              <div class="field" :class="{ 'has-error': errors.has('form-change-number.hp') }">
                <div class="hp-label-wrapper">
                  <label class="text-label" for="hp">Mobile Phone number <span class="required">*</span></label>
                  <label class="text-label" for="hp">Contoh: <strong>85612345678</strong></label>
                </div>
                <div class="fieldarea fieldarea--addon fieldarea--input-with-text">
                  <div>
                    <span class="fieldarea__addon" @click.prevent="showOverseas()">
                      <template v-if="userCountry && !Object.keys(userCountry).length">
                        <span class=""
                          ><img src="/assets/img/indonesia-flag.svg" class="field__icon-flag" />+62<img
                            src="/assets/img/triangle-down.svg"
                            class="field__icon-triangle"
                        /></span>
                      </template>
                      <template v-else>
                        <span class=""
                          ><img :src="userCountry.flag" class="field__icon-flag" />{{ `${userCountry.phone_code}`
                          }}<img src="/assets/img/triangle-down.svg" class="field__icon-triangle"
                        /></span>
                      </template>
                    </span>
                    <overseas-phone v-if="isShowModalOverseas" />
                  </div>
                  <input
                    id="minhp"
                    v-model="phone_no"
                    v-validate="'required|numeric|min:4|max:14'"
                    type="text"
                    class="text addon"
                    name="minhp"
                    autocomplete="off"
                  />
                </div>
                <p v-show="errors.has('form-change-number.minhp')" class="alert">
                  {{ errors.first('form-change-number.minhp') }}
                </p>
              </div>
              <div class="change-number-action">
                <template v-if="!showLoader">
                  <button v-show="isDesktop" class="button button-dismiss" @click.prevent="closeModal">CANCEL</button>
                  <button
                    type="submit"
                    class="button button-danger"
                    :disabled="errors.has('form-change-number.minhp') || !phone_no"
                  >
                    CHANGE AND SEND OTP
                  </button>
                </template>
                <loaderspin v-else />
              </div>
            </form>
          </div>
        </div>
      </template>
    </GModal>
  </div>
</template>

<script>
export default {
  name: 'ModalChangeNumber',
  components: {
    OverseasPhone: () => import('@/components/global/login/overseas-phone'),
  },
  props: {
    isRegistered: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      phone_no: '',
      showLoader: false,
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    isShowModalOverseas() {
      return this.$store.state.modal.isModalShow.overseasPhone;
    },
    userCountry() {
      return this.$store.state.otp.userCountry;
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'changeNumber',
      });
    },
    showOverseas() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'overseasPhone',
      });
    },
  },
};
</script>
